export enum OnFarmPaymentStatus {
  PENDING = 'Pending',
  SUCCESSFUL = 'Successful',
  FAILED = 'Failed',
  NOT_ATTEMPTED = 'NotAttempted',
}

export enum OnFarmPaymentMethod {
  ACH = 'ACH',
  RECURRING_CARD = 'RecurringCard',
  DIRECT = 'Direct',
  NOT_AVAILABLE = 'NotAvailable',
  EXTERNAL = 'External',
}

export enum OnFarmPaymentMode {
  MANUAL = 'Manual',
  AUTOMATIC_RECURRING = 'AutomaticRecurring',
  PAY_NOW = 'PayNow',
}
